export const NEGATIVE_INFINITY = '-inf'
export const INIFINITY = 'inf'

export const handlePriceInputChangeHelper = (
    type: 'min' | 'max',
    value: string,
    priceRange: {min?: string; max?: string},
    selectedCioFacets: any,
    setPriceRange: (updater: (prev: any) => any) => void,
    dispatchSelectedFacets: (action: any) => void
) => {
    setPriceRange((prev: any) => ({
        ...prev,
        [type]: value || undefined
    }))

    const otherType = type === 'min' ? 'max' : 'min'
    const otherValue = priceRange?.[otherType] || ''
    const newSelectedFacets = {...selectedCioFacets}
    if ('price' in newSelectedFacets) {
        delete newSelectedFacets.price
    }
    if ((type === 'min' && !value && !otherValue) || (type === 'max' && !value && !otherValue)) {
        dispatchSelectedFacets({
            type: 'SET_CIO_SELECTED_FACETS',
            payload: newSelectedFacets
        })
        return
    }

    const minValue =
        type === 'min'
            ? value === ''
                ? NEGATIVE_INFINITY
                : value
            : priceRange?.min || NEGATIVE_INFINITY
    const maxValue =
        type === 'max' ? (value === '' ? INIFINITY : value) : priceRange?.max || INIFINITY

    dispatchSelectedFacets({
        type: 'SET_CIO_SELECTED_FACETS',
        payload: {
            ...newSelectedFacets,
            price: [
                {
                    value: `${minValue} - ${maxValue}`,
                    display_name: `${minValue} - ${maxValue}`
                }
            ]
        }
    })
}

export const getNewSelectedFilters = (
    selectedCioFacets: any,
    category: string,
    option: {value: string; display_name: string; count: number}
) => {
    const categoryExists = selectedCioFacets[category]
    const newCategoryValues = categoryExists?.some((item: any) => item.value === option.value)
        ? categoryExists.filter((item: any) => item.value !== option.value)
        : [...(categoryExists || []), {value: option.value, display_name: option.display_name}]

    const newSelectedFilters = {
        ...selectedCioFacets,
        ...(newCategoryValues.length > 0 ? {[category]: newCategoryValues} : {})
    }

    if (newCategoryValues.length === 0) {
        delete newSelectedFilters[category]
    }

    return newSelectedFilters
}
